export default function formatNumber(num) {
  const amount = Number(num).toFixed(2)
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    currency: 'USD',
  }).format(Number(amount))
}
